import {getUserData} from '@common'
import {APIMethod} from '@enums'
import {getUserSelectionAtom} from '@state'

import {fetchData} from 'api/api'
import {getDefaultStore} from 'jotai'

import {ProductRequest, ProductResponse} from './types'

/**
 * @returns All Products for current company
 */
export const getProducts = async (): Promise<ProductResponse[]> => {
  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser.id]

  return fetchData({
    method: APIMethod.GET,
    url: `product/company/${userSelection?.companyId || ''}`,
  })
}

/**
 * @param id Product ID
 */
export const getProductById = async (id: string): Promise<ProductResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `product/${id}`,
  })
}

/**
 * Update Product
 */
export const updateProduct = async (id: string, body: ProductRequest): Promise<ProductResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `product/${id}`,
    body,
  })
}

/**
 * Create Product
 */
export const createProduct = async (body: ProductRequest): Promise<ProductResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: `product`,
    body,
  })
}

/**
 * Link Product → Accessory
 */
export const linkProductToAccessory = async (productId: string, accessoryId: string): Promise<void> => {
  await fetchData({
    method: APIMethod.POST,
    url: `product/${productId}/accessories/${accessoryId}`,
  })
}

/**
 * Unlink Product → Accessory
 */
export const unlinkProductFromAccessory = async (productId: string, accessoryId: string): Promise<void> => {
  await fetchData({
    method: APIMethod.DELETE,
    url: `product/${productId}/accessories/${accessoryId}`,
  })
}

/**
 * Bulk upload products
 */
export const bulkProductUpload = async (body: string): Promise<void> => {
  await fetchData({
    method: APIMethod.POST,
    url: 'product/bulk-insert',
    body: JSON.parse(body),
  })
}
